import { Link } from "react-router-dom";
import Avatar from "@/components/base/Avatar";
import { formatViews, getCategoryName } from "@/utils/format";

interface VideoCardProps {
  id: string;
  title: string;
  cover: string;
  author: string;
  category: string;
  views: number;
  duration: string;
  publishDate: string;
  authorType?: string;
}

export default function VideoCard({
  id,
  title,
  cover,
  author,
  category,
  views,
  duration,
  publishDate,
  authorType,
}: VideoCardProps) {
  const tone = category === "entertainment" ? "accent" : category === "life" ? "secondary" : "primary";
  return (
    <Link
      to={`/video/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={`${title} - 呱呱视频社区`}
          title={`${title} - 呱呱视频社区精彩视频`}
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-white text-xs">
          {duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-800 text-xs">
          {getCategoryName(category)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/20 transition-colors">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-medium text-sm text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="mt-3 flex items-center gap-2">
          <Avatar name={author} size="sm" tone={tone} />
          <span className="text-xs text-foreground-600 truncate flex-1">{author}</span>
          {authorType === "official" && (
            <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-xs whitespace-nowrap">官方</span>
          )}
        </div>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line" aria-hidden="true"></i>
            {formatViews(views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {publishDate}
          </span>
        </div>
      </div>
    </Link>
  );
}